import type { FC } from 'react';

import heartEmpty from 'assets/playlist/heart_empty_white.svg';
import heartFull from 'assets/playlist/heart_full.png';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { MenuItemStyle } from './MenuItem.styles';

interface MenuItemProps {
  onClick?: () => void;
  isFavorite?: boolean;
  withIcon?: boolean;
  translateId: string;
}

const MenuItem: FC<MenuItemProps> = ({ onClick, translateId, isFavorite, withIcon }) => {
  const colors = useSelector(colorsSelector);

  const heartIcon = isFavorite ? heartFull : heartEmpty;

  return (
    <MenuItemStyle {...{ colors, onClick }}>
      {withIcon && heartIcon && <img src={heartIcon} alt="favorite"
        style={{ width: 20, height: 20, marginLeft: 10, marginRight: 10 }}
      />}
      <FormattedMessage id={translateId} />
    </MenuItemStyle>
  );
};

export default MenuItem;

// {
//   favoritePlaylist && <IconButton aria-label="favorite" onClick={handleFavoriteClick}>
//     <img
//       src={isLiked ? heartFull : heartEmpty}
//       alt="favorite"
//       style={{ width: 25, height: 25, marginLeft: 10, marginRight: 10 }}
//     />
//   </IconButton>
// }